import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useApplication } from '../../model/context/applicationContext';
import { Dialog } from '../components/dialog';
import { XmlTreeViewer } from './xmlTreeViewer';

export const XmlQuerySelector = ({ handleQuery }: { handleQuery: (query: string) => void }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState<{ path: string; value: string }>();
  const { applicationXml } = useApplication();

  return (
    <>
      <Button size="small" variant="outlined" onClick={() => setModalOpen(true)}>
        <FormattedMessage id="xslQuery.modal.button.label" defaultMessage="Insert value" />
      </Button>
      <Dialog
        title={<FormattedMessage id="xslQuery.modal.title" defaultMessage="Insert Value" />}
        content={
          applicationXml ? (
            <Stack spacing={1}>
              <Typography>
                <FormattedMessage
                  id="xslQuery.modal.helperText"
                  defaultMessage='Find the node in the xml-tree you want to insert. The path will be inserted to the variables query field as a <xsl:value-of select="path/to/node" /> query.'
                />
              </Typography>
              <XmlTreeViewer
                xmlString={applicationXml}
                onSelectNode={(path: string, value: string) => setSelectedNode({ path, value })}
              />
              <Box>
                <Typography fontWeight="bold">
                  <FormattedMessage
                    id="xslQuery.modal.selectedPath"
                    defaultMessage="Selected path:"
                  />
                </Typography>
                <Typography sx={{ wordBreak: 'break-word' }}>{selectedNode?.path}</Typography>
              </Box>
              <Box>
                <Typography fontWeight="bold">
                  <FormattedMessage
                    id="xslQuery.modal.selectedValue"
                    defaultMessage="Selected value:"
                  />
                </Typography>
                <Typography>{selectedNode?.value}</Typography>
              </Box>
            </Stack>
          ) : null
        }
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        actions={
          <>
            <Button variant="contained" color="secondary" onClick={() => setModalOpen(false)}>
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                selectedNode?.path && handleQuery(selectedNode?.path);
                setModalOpen(false);
              }}>
              <FormattedMessage id="Insert" />
            </Button>
          </>
        }
      />
    </>
  );
};
